/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AutocompleteResponse } from './customPeopleTagTypes';

export const mockFaceId = 'the-face-id';
export const mockCurrentPerson = {
  face_uri: 'https://www.faceImage1.com',
  person_id: mockFaceId,
  tag_name: 'Lydia Williams'
};
export const mockSelectedPerson = {
  face_uri: 'https://www.faceImage2.com',
  person_id: 'person-id-2',
  tag_name: 'Lionel Lee',
};

export const mockAutoCompleteResponse: AutocompleteResponse = {
  data: [
    mockCurrentPerson,
    mockSelectedPerson,
    {
      face_uri: 'https://www.faceImage3.com',
      person_id: 'person-id-3',
      tag_name: 'Tyler Lane',
    }
  ]
};
